module.exports = __webpack_public_path__ + "img/tokopedia.ee1901ea.png";